import { render } from "./SetupTwoFactorAuthenticationForm.vue?vue&type=template&id=01600858"
import script from "./SetupTwoFactorAuthenticationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupTwoFactorAuthenticationForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Profile/Partials/SetupTwoFactorAuthenticationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01600858"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01600858', __exports__)) {
    api.reload('01600858', __exports__)
  }
  
  module.hot.accept("./SetupTwoFactorAuthenticationForm.vue?vue&type=template&id=01600858", () => {
    api.rerender('01600858', render)
  })

}


export default __exports__